"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var react_router_dom_1 = require("react-router-dom");
var TabList_1 = __importDefault(require("../../components/tabs/TabList"));
var TabContextProvider_1 = __importDefault(require("../../contexts/__providers/TabContextProvider"));
var layout_context_1 = require("../../contexts/layout-context");
var IpisUnexpectedError_1 = require("../../screens/error/IpisUnexpectedError");
var PageHeader_1 = require("./PageHeader");
var IpisWindowModalsProvider_1 = require("../modals/window-modals/IpisWindowModalsProvider");
var IpisLayout = function (props) {
    var _a = (0, react_1.useState)(false), tabProps = _a[0], setTabProps = _a[1];
    var _b = (0, react_1.useState)(undefined), externalBrandTheme = _b[0], setExternalBrandTheme = _b[1];
    var location = (0, react_router_dom_1.useLocation)();
    var mostRecentPath = react_1.default.useRef(location.pathname);
    (0, react_1.useEffect)(function () {
        if (mostRecentPath.current !== location.pathname) {
            setTabProps(false);
        }
    }, [location.pathname]);
    return ((0, jsx_runtime_1.jsx)(layout_context_1.IpisLayoutContext.Provider, { value: { externalBrandTheme: externalBrandTheme, setExternalBrandTheme: setExternalBrandTheme }, children: (0, jsx_runtime_1.jsxs)(ConditionalTabContext, { tabProps: tabProps, children: [props.sideBar, (0, jsx_runtime_1.jsx)(PageHeader_1.PageHeader, {}), (0, jsx_runtime_1.jsxs)(react_error_boundary_1.ErrorBoundary, { fallbackRender: function (props) {
                        return (0, jsx_runtime_1.jsx)(IpisUnexpectedError_1.IpisUnexpectedError, { error: props.error });
                    }, children: [props.children, tabProps && ((0, jsx_runtime_1.jsx)(TabList_1.default, { className: "col-start-1 row-start-3 lg:row-start-2" }))] }), (0, jsx_runtime_1.jsx)(IpisWindowModalsProvider_1.IpisWindowModalsProvider, {})] }, "tabContext") }));
};
exports.IpisLayout = IpisLayout;
var ConditionalTabContext = function (props) {
    if (props.tabProps) {
        return ((0, jsx_runtime_1.jsx)(TabContextProvider_1.default, __assign({}, props.tabProps, { children: props.children })));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
};
